export default "__VITE_ASSET__CCT9uR4W__"